module.exports = __webpack_public_path__ + "img/reciprocal.9be0eb01.gif";